// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__2fL6n","header":"PatientQuestionnaire_header__2OIr9","info":"PatientQuestionnaire_info__2gDLZ"};